import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  pageType:"login",
  user: null,
  token: null,
  posts: [],
  rid:null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTest: (state) => {
      state.pageType = state.pageType === "login" ? "user" : "login";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
    },
    setRid: (state,action) => {
      state.rid = action.payload.rid;
    },
   
  },
});

export const { setTest, setLogin, setLogout, setFriends, setPosts, setPost , setRid} =
  authSlice.actions;
export default authSlice.reducer;